import { normalizeRawCallingListRanking } from '../../lib'
import {
  CampaignCallAction,
  CampaignCallStatus,
  CampaignExtendedCallingList,
} from '../../model/campaign'

export const mapExtendedCallingListFromRawData = (rawData: any): CampaignExtendedCallingList => ({
  id: rawData.Id,
  isr: rawData.ISR,
  partnerId: rawData.PartnerId,
  locationId: rawData.LocationId,
  campaignId: rawData.CampaignId,
  isVisible: rawData.IsVisible ?? true,
  ranking: normalizeRawCallingListRanking(rawData.Ranking),
  communicationName: rawData.CommunicationName,
  country: rawData.Country,
  partnerType: rawData.PartnerType,
  hierarchyType: rawData.HierarchyType,
  agreements: rawData.Agreements?.split(',') || [],
  programs: rawData.Programs?.split(',') || [],
  agentRank: rawData.AgentRank,
  freqFlag: rawData.FreqFlag,
  isAmplifyMember: Boolean(rawData.IsAmplifyMember),
  callStatus: rawData.CallStatus || CampaignCallStatus.New,
  callAction: rawData.CallAction || CampaignCallAction.None,
  specialPricingFlag: rawData.SpecialPricingFlag || 'N',
})
